<app-center-container
  [title]="title"
  [showClose]="true"
  (close)="close()">

  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
      <app-input-wrapper
        [control]="form.get('research_mode')">
        <input
          type="checkbox"
          class="checkbox_input"
          formControlName="research_mode"
          name="research_mode"
          id="research_mode">
          <label
            for="research_mode"
            class="checkbox_label">
            Research Mode
          </label>
        </app-input-wrapper>
        <app-input-wrapper
          [control]="form.get('eye_telemetry_enabled')">
          <input
            type="checkbox"
            class="checkbox_input"
            formControlName="eye_telemetry_enabled"
            name="eye_telemetry_enabled"
            id="eye_telemetry_enabled">
            <label
              for="eye_telemetry_enabled"
              class="checkbox_label">
              Eye Telemetry Enabled
            </label>
          </app-input-wrapper>
          <app-input-wrapper
            [control]="form.get('blue_pupillometry_telemetry_enabled')">
            <input
              type="checkbox"
              class="checkbox_input"
              formControlName="blue_pupillometry_telemetry_enabled"
              name="blue_pupillometry_telemetry_enabled"
              id="blue_pupillometry_telemetry_enabled">
              <label
                for="blue_pupillometry_telemetry_enabled"
                class="checkbox_label">
                Blue Pupillometry Telemetry Enabled
              </label>
            </app-input-wrapper>
            <app-input-wrapper
              [control]="form.get('suprat_quadrant_telemetry_enabled')">
              <input
                type="checkbox"
                class="checkbox_input"
                formControlName="suprat_quadrant_telemetry_enabled"
                name="suprat_quadrant_telemetry_enabled"
                id="suprat_quadrant_telemetry_enabled">
                <label
                  for="suprat_quadrant_telemetry_enabled"
                  class="checkbox_label">
                  SupraT Quadrant Telemetry Enabled
                </label>
              </app-input-wrapper>
              <app-input-wrapper
                [control]="form.get('sensorimotor_suite_cover_telemetry_enabled')">
                <input
                  type="checkbox"
                  class="checkbox_input"
                  formControlName="sensorimotor_suite_cover_telemetry_enabled"
                  name="sensorimotor_suite_cover_telemetry_enabled"
                  id="sensorimotor_suite_cover_telemetry_enabled">
                  <label
                    for="sensorimotor_suite_cover_telemetry_enabled"
                    class="checkbox_label">
                    Sensorimotor Suite Cover Telemetry Enabled
                  </label>
                </app-input-wrapper>
                <app-input-wrapper
                  [control]="form.get('eoms_telemetry_enabled')">
                  <input
                    type="checkbox"
                    class="checkbox_input"
                    formControlName="eoms_telemetry_enabled"
                    name="eoms_telemetry_enabled"
                    id="eoms_telemetry_enabled">
                    <label
                      for="eoms_telemetry_enabled"
                      class="checkbox_label">
                      EOMS Telemetry Enabled
                    </label>
                  </app-input-wrapper>
                  <app-input-wrapper
                    [control]="form.get('pupillometry_telemetry_enabled')">
                    <input
                      type="checkbox"
                      class="checkbox_input"
                      formControlName="pupillometry_telemetry_enabled"
                      name="pupillometry_telemetry_enabled"
                      id="pupillometry_telemetry_enabled">
                      <label
                        for="pupillometry_telemetry_enabled"
                        class="checkbox_label">
                        Pupillometry Telemetry Enabled
                      </label>
                    </app-input-wrapper>
                    <app-input-wrapper
                      [control]="form.get('speech_reports')">
                      <input
                        type="checkbox"
                        class="checkbox_input"
                        formControlName="speech_reports"
                        name="speech_reports"
                        id="speech_reports">
                        <label
                          for="speech_reports"
                          class="checkbox_label">
                          Speech Reports
                        </label>
                      </app-input-wrapper>
                      <app-input-wrapper
                        [control]="form.get('waggoner_module')">
                        <input
                          type="checkbox"
                          class="checkbox_input"
                          formControlName="waggoner_module"
                          name="waggoner_module"
                          id="waggoner_module">
                          <label
                            for="waggoner_module"
                            class="checkbox_label">
                            Enable Waggoner Module
                          </label>
                        </app-input-wrapper>
                        <app-input-wrapper
                          [control]="form.get('d15_voice_input_module')">
                          <input
                            type="checkbox"
                            class="checkbox_input"
                            formControlName="d15_voice_input_module"
                            name="d15_voice_input_module"
                            id="d15_voice_input_module">
                            <label
                              for="d15_voice_input_module"
                              class="checkbox_label">
                              Enable D15 Voice Input Module
                            </label>
                          </app-input-wrapper>
                          <app-input-wrapper
                            [control]="form.get('enable_home_management')">
                            <input
                              type="checkbox"
                              class="checkbox_input"
                              formControlName="enable_home_management"
                              name="enable_home_management"
                              id="enable_home_management">
                              <label
                                for="enable_home_management"
                                class="checkbox_label">
                                Enable Home Management
                              </label>
                            </app-input-wrapper>
                          <br>
                            <button
                              class="button button--primary form_button"
                              type="submit"
                              [disabled]="!form.valid || !form.dirty">
                              <span class="regular">{{ 'done' | translate }}</span>
                            </button>
                          </form>
                        }

                      </app-center-container>

                      @if (isLoading) {
                        <app-loader></app-loader>
                      }
